/* The credit acts' pill — the ledger's (T-C2) and the client card's band (T-K1), which draw the
 * same `btn card`. The TREATMENT is `shared/ui/ghostButton`, worn beside it (`creditActClass`),
 * and this holds only the pill's geometry and its ink: the mockup's card button is in `--text`,
 * so the ink outranks ghost's secondary one — but never on a refused act, which keeps ghost's
 * refused look. Two-part selectors, so the chunk order never decides. */
.act {
  justify-content: center;
  height: var(--h-booking-control);
  padding: var(--space-0) var(--space-4);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  white-space: nowrap;
  background: var(--bg-card);
  border-radius: var(--r-pill);
}

.act:not([aria-disabled='true'], :disabled) {
  color: var(--text);
}
